import React, { Component } from 'react';
import { View, TextInput, Button, Text, Link, Scene, TelPickerInput, isWeb } from 'core';
import { style, theme, COUNTRIES } from 'constants';
import { lang } from 'lang';
import { IcoBack } from 'icons';
import { version } from '../../../package.json';

const styles = style({
  container: {
    flex: 1,
    alignItems: 'center'
  },
  back: {
    alignSelf: 'stretch',
    alignItems: 'flex-start',
    marginVertical: 30
  },
  text: {
    textAlign: 'center'
  },
  email_input: {
    borderColor: theme.primary_color_lighten(0.6),
    borderWidth: 1
  },
  email_input_rtl: {
    direction: isWeb ? 'ltr' : 'rtl'
  },
  btn: {
    marginTop: 30
  },
  exmaple: {
    alignSelf: 'flex-end',
    paddingVertical: 5
  }
});

class Auth extends Component {
  render() {
    const { back, status, onSuccess, setAccount, account, country_code, use_phone, setMethod, index, is_add_account, action } = this.props;
    return (
      <Scene style={styles.container}>
        {is_add_account ? null : <Link style={styles.back} size={18} icon={IcoBack} title={lang.BACK} onPress={back} selected />}

        <View style={styles.container}>
          {is_add_account ? null : <Text style={[styles.text, { fontSize: 32 }]}>{lang.LOG_IN}</Text>}
          <Text style={[styles.text, { fontSize: 14, marginTop: 10 }]}>{use_phone ? lang.PHONE : lang.EMAIL}</Text>

          <View
            style={{
              flexDirection: 'row',
              marginTop: 30,
              marginBottom: 5
            }}
          >
            {use_phone ? (
              <TelPickerInput
                value={{ code: country_code, phone: account }}
                onChange={({ code, phone }) => setAccount({ account: phone, country_code: code })}
                autoFocus={index === 1}
                style={{ borderColor: theme.primary_color_lighten(0.4) }}
              />
            ) : (
              <TextInput
                key={`key_${index === 1}`}
                returnKeyType="next"
                autoCapitalize="none"
                autoCorrect={false}
                keyboardType="email-address"
                autoFocus={index === 1}
                onChangeText={account => setAccount({ account, country_code: country_code })}
                style={[styles.email_input, lang.IS_RTL && styles.email_input_rtl]}
                value={account}
                placeholder={lang.EMAIL_PH}
              />
            )}
          </View>
          <Link size={12} style={styles.exmaple} title={use_phone ? lang.USE_EMAIL : lang.USE_PHONE} onPress={setMethod} selected />
          <Button
            status={status}
            onSuccess={onSuccess}
            style={styles.btn}
            title={lang.NEXT}
            onPress={() => action({ account, tel_code: COUNTRIES[country_code].tel })}
            disabled={account.trim() === ''}
          />
        </View>
        <Text style={{ color: theme.gray_color_alpha(0.4), marginTop: 10, alignSelf: 'center' }}>fosol v{version}</Text>
      </Scene>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/components/login/auth.js